import { IAppState } from '../../../AppModulesWrapper';

export function selectOfferId(state: IAppState): number | null {
  return state.servicePickerWidget.offer.id;
}
